import { createContext, useContext } from 'react';
import { anchorStyles } from '../components/anchor/anchor.styles.esm.js';
import { avatarStyles } from '../components/avatar/avatar.styles.esm.js';
import { buttonStyles } from '../components/button/button.styles.esm.js';
import { cardStyles } from '../components/card/card.styles.esm.js';
import { checkboxStyles } from '../components/checkbox/checkbox.styles.esm.js';
import { gridListItemStyles } from '../components/collections/grid-list-item.styles.esm.js';
import { listBoxItemStyles } from '../components/collections/list-box-item.styles.esm.js';
import { comboBoxStyles } from '../components/combo-box/combo-box.styles.esm.js';
import { inputStyles } from '../components/field/input/input.styles.esm.js';
import { fieldGroupStyles } from '../components/field/field-group/field-group.styles.esm.js';
import { labelStyles } from '../components/field/label/label.styles.esm.js';
import { imageStyles } from '../components/image/image.styles.esm.js';
import { logoStyles } from '../components/logo/logo.styles.esm.js';
import { modalStyles } from '../components/modal/primitives/modal.styles.esm.js';
import { propertyImageStyles } from '../components/property-image/property-image.styles.esm.js';
import { radioStyles } from '../components/radio/styles/radio.styles.esm.js';
import { selectStyles } from '../components/select/select.styles.esm.js';
import { skeletonStyles } from '../components/skeleton/skeleton.styles.esm.js';
import { spinnerStyles } from '../components/spinner/spinner.styles.esm.js';
import { textStyles } from '../components/text/text.styles.esm.js';
import { textFieldStyles } from '../components/field/text-field/text-field.styles.esm.js';
import { textAreaStyles } from '../components/field/text-area/text-area.styles.esm.js';

var defaultTheme = {
  components: {
    Anchor: anchorStyles.base,
    Avatar: avatarStyles.base,
    Button: buttonStyles.base,
    Card: cardStyles.base,
    Checkbox: checkboxStyles.base,
    ComboBox: comboBoxStyles.base,
    DropdownItem: gridListItemStyles.base,
    FieldGroup: fieldGroupStyles.base,
    Image: imageStyles.base,
    Input: inputStyles.base,
    Label: labelStyles.base,
    Logo: logoStyles.base,
    ListBoxItem: listBoxItemStyles.base,
    Modal: modalStyles.base,
    PropertyImage: propertyImageStyles.base,
    Radio: radioStyles.base,
    Select: selectStyles.base,
    Skeleton: skeletonStyles.base,
    Spinner: spinnerStyles.base,
    Text: textStyles.base,
    TextArea: textAreaStyles.base,
    TextField: textFieldStyles.base
  }
};
var ThemeContext = /*#__PURE__*/createContext({
  theme: defaultTheme
});
var ThemeProvider = ThemeContext.Provider;
function useTheme() {
  var _useContext;
  return ((_useContext = useContext(ThemeContext)) === null || _useContext === void 0 ? void 0 : _useContext.theme) || defaultTheme;
}
function useComponentTheme(component) {
  var theme = useTheme();
  return theme.components[component];
}

export { ThemeProvider, useComponentTheme };
//# sourceMappingURL=theme.context.esm.js.map
